import React from "react";
import DrawResultPage from "./DrawResultPage";

const EightPmResult = () => <DrawResultPage time="8pm" />;

export default EightPmResult;
